import React from "react";
import "./common.css";
import profileIc from "../../assets/png/profile-ic.png";
const SuppliedBy = ({ suppliers }) => {
  if (!suppliers || suppliers.length === 0) return null;

  // Show first 3 avatars
  const visibleSuppliers = suppliers.slice(0, 3);
  const remainingCount = suppliers.length - visibleSuppliers.length;

  // Build supplier text dynamically
  const displayedNames = suppliers.slice(0, 3).map((s) => s.name);
  const text =
    displayedNames.join(", ") +
    (remainingCount > 0 ? ` and ${remainingCount} others` : "");

  return (
    <div className="supplied-container">
      <div className="avatars">
        {visibleSuppliers.map((s, index) => (
          <img
            key={index}
            src={s.image || profileIc} 
            alt={s.name || "Profile"}
            className="avatar"
            style={{ zIndex: visibleSuppliers.length - index }}
          />
        ))}

        {remainingCount > 0 && (
          <div className="avatar more">+{remainingCount}</div>
        )}
      </div>

      <div className="fs-12 supplier-text">
        Supplied by <span className="highlight">{text}</span>
      </div>
    </div>
  );
};

export default SuppliedBy;
